import { createI18n } from 'vue3-i18n'

import en from '@/locales/en/en'
import ja from '@/locales/ja/ja'

const messages = {
  en,
  ja
}

const i18n = createI18n({
  locale: localStorage.getItem('lang') || 'ja',
  messages
})

export default i18n
